import {Component, input} from '@angular/core';
import {NgStyle} from "@angular/common";
import {ColorUtils} from "../../../utils/color-utils";

@Component({
  selector: 'tags',
  standalone: true,
  imports: [
    NgStyle
  ],
  templateUrl: './tags.component.html'
})
export class TagsComponent {
  tags = input.required<any[]>();

  getDefaultColor(name: string): string {
    return ColorUtils.getColor(`tag:${name}`, 0.8);
  }

  getTextColor(backgroundColor: string): 'white' | 'black' {
    // Check if color is hsla
    const hslaMatch = backgroundColor.match(/hsla\(\s*([0-9]+)\s*,\s*([0-9]+)%\s*,\s*([0-9]+)%/);
    if (hslaMatch) {
      const h = Number(hslaMatch[1]), s = Number(hslaMatch[2]), l = Number(hslaMatch[3]);
      const [r, g, b] = ColorUtils.hslToNormalizedRgb(h, s, l);
      return this.getTextColorFromNormalizedRgb(r, g, b);
    }
    // Check if color is hex
    if (/^#[0-9A-F]{6}$/i.test(backgroundColor)) {
      return this.getTextColorFromHex(backgroundColor);
    }
    return 'white';
  }

  private getTextColorFromNormalizedRgb(r: number, g: number, b: number): 'white' | 'black' {
    const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
    return luminance < 0.6 ? 'white' : 'black';
  }

  private getTextColorFromHex(hex: string): 'white' | 'black' {
    const [r, g, b] = hex.replace(/^#/, "")
      .match(/.{2}/g)!
      .map(v => parseInt(v, 16) / 255.0);
    return this.getTextColorFromNormalizedRgb(r, g, b);
  }
}
